export default __webpack_public_path__ + "static/media/astronaut.4af46f3e.svg";